<template>
  <div>
    <div class="logo">
       <img src="@/assets/logo-fas.png" alt="">
    </div>
    <div class="subTitle">
      <p>{{subTitle}}</p>
    </div>
    <div class="description">
      <p>{{description}}</p>
    </div>
  </div>
</template>

<script>

export default {
  data() {
    return {
    }
  },
  props: ['subTitle', 'description']
}
</script>

<style scoped>
.logo {
  display: flex;
  justify-content: center;
}
.subTitle {
  margin-top: 30px;
  font-family: Roboto;
  font-weight: 500;
  font-size: 24px;
  color: #222222;
}
</style>
